import React from "react";
import { ErrorBoundary } from "@sentry/react";
// import useNetwork from "./helpers/useNetwork";

import Header from "./common/components/Header";
import RoutedTabs from "./common/components/RoutedTabs";
import ProfileError from "./common/components/ProfileError";

import "react-bootstrap-typeahead/css/Typeahead.css";
import "./App.css";

function App() {
    // const isOnline = useNetwork();

    return (
        <div className="App">
            <ErrorBoundary fallback={<ProfileError />}>
                <Header />
                <RoutedTabs />
            </ErrorBoundary>
            {/* {!isOnline ? (
                <div className="offline-overlay">
                    <div
                        className="bubble-show justify-content-center align-items-center d-flex flex-column p-5"
                        style={{ background: "white" }}
                    >
                        <p>FoliEdge requires an internet connection, but you seem to be offline.</p>
                        <p>Something may be wrong with your connection.</p>
                        <p>Attempting to refresh the page may result in lost work.</p>
                        <p>This message will disappear when you appear to be back online.</p>
                    </div>
                </div>
            ) : null} */}
        </div>
    );
}

export default App;
